module.exports = __webpack_public_path__ + "static/media/paypal.4d090e91.png";